import Scammer from './scammer.png'
import Boy from './boy.png'
import Female from './female.png'
import Arrow from './arrow.svg'
import Sign from './sign.png'

export default {
    Scammer,
    Boy,
    Female,
    Arrow,
    Sign,
}